/** Shared footer pill styles — Figma Grey/100 #E7E7E7, h 48px, px 16px */
export const sidebarFooterPillClass =
  'sidebar-footer-pill flex h-[48px] w-full items-center justify-between rounded-full px-4 border transition-colors';

export const sidebarFooterPillIconClass =
  'sidebar-footer-pill flex h-[48px] w-full items-center justify-center rounded-full px-4 border transition-colors';

/** Poppins Medium 14px / 160% line-height, Figma Base/Black · dark Grey/300 */
export const sidebarFooterPillLabelClass =
  'font-sans text-[14px] font-medium leading-[1.6] tracking-normal text-black dark:text-grey-300';

export const sidebarFooterPillIconColorClass = 'text-black dark:text-true-white';

export const SIDEBAR_FOOTER_LEFT_ICON_SIZE = 24;
export const SIDEBAR_FOOTER_RIGHT_ICON_SIZE = 20;
